<template>
    <div class="main-container">
        <!-- Navbar section -->
        <Navbar/>

        <!-- hero section -->
        <GenericHero :title="$t('language_blog.title')" :subtitle="$t('language_blog.subtitle')" :image="require('../../assets/img/trustami/language_blog.svg')" />

        <ContentSection>
            <template #main>
                <p>{{ $t("language_blog.section_1_1") }}</p>
                <p>{{ $t("language_blog.section_1_2") }}</p>
                <ul>
                    <li>{{ $t("language_blog.section_1_3") }}</li>
                    <li>{{ $t("language_blog.section_1_4") }}</li>
                    <li>{{ $t("language_blog.section_1_5") }}</li>
                </ul>
            </template>
        </ContentSection>

        <ContentSection>
            <template #header>{{ $t("language_blog.section_2") }}</template>
            <template #main>
                <p>{{ $t("language_blog.section_2_1") }}</p>
                <p>{{ $t("language_blog.section_2_2") }}</p>
                <p>{{ $t("language_blog.section_2_3") }}</p>
                <p v-html="$t('language_blog.section_2_4')"></p>
                <p>{{ $t("language_blog.section_2_5") }}</p>
            </template>
        </ContentSection>

        <ContentSection>
            <template #main>
                <p v-html="$t('language_blog.section_footer')"></p>
            </template>
        </ContentSection>

        <!-- footer section -->
        <FooterMain/>

    </div>
</template>

<script>
import GenericHero from '../../comp_trustami/GenericHero';
import ContentSection from '../../comp_trustami/Research/ContentSection';
import FooterMain from '../../comp_trustami/FooterMain';
import Navbar from "../../comp_trustami/NavbarSub";

export default {
    name: 'app',
    components: {
        Navbar,
        GenericHero,
        ContentSection,
        FooterMain,
    },

    metaInfo: {
        title: 'Language Detection API - Trustami.AI Web Services',
        meta: [
            {
                name: 'description',
                content: 'Automatically detect the language of a text.'
            }
        ],
        htmlAttrs: {
            lang: 'en',
            amp: true
        }
    }
}
</script>
